import React, { useState, useEffect, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom'; // Added import

// Import onboarding page components
import WelcomeOnboarding from '../../components/onboarding/pages/Welcome'; // Added import
import BrancheOnboarding from '../../components/onboarding/pages/Branche';
import ResultsOnboarding from '../../components/onboarding/pages/Results';
import SuccessOnboarding from '../../components/onboarding/pages/Success';

// Define types for CPV data if not already globally available
interface CpvCodeData {
  cpvcode: string;
  omschrijving: string;
}

const NoCpvsPage: React.FC = () => {
  // State for managing the onboarding flow
  const [currentPage, setCurrentPage] = useState<string>("welcome"); // "welcome", "keywords", "results", "success"
  const [keywordsList, setKeywordsList] = useState<string[]>([]);
  const [selectedCpvs, setSelectedCpvs] = useState<CpvCodeData[]>([]); // Use CpvCodeData type

  const navigate = useNavigate(); // Initialized useNavigate

  // Navigation handlers
  const handleWelcomeNext = () => {
    setCurrentPage("keywords");
  };

  const handleBrancheNext = () => {
    // BrancheOnboarding calls setKeywordsList directly via its setKeywords prop
    // before this onNext handler is invoked. The keywordsList state will be
    // updated for the next render cycle when ResultsOnboarding is displayed.
    setCurrentPage("results");
  };

  const handleResultsNext = () => {
    // The selection state (selectedCpvs) is already updated by ResultsOnboarding
    // before this onNext handler is invoked. The selectedCpvs state will be
    // updated for the next render cycle when SuccessOnboarding is displayed.
    window.location.reload(); // Reload the page instead of showing success screen
  };

  const handleGoBack = () => {
    if (currentPage === "keywords") {
      setCurrentPage("welcome");
    } else if (currentPage === "results") {
      setCurrentPage("keywords");
    } else if (currentPage === "success") {
      setCurrentPage("results");
    }
    // Potentially add navigation away if on the first step (keywords) and user wants to "close/cancel"
  };

  const handleFinishOnboarding = () => {
    // Logic to navigate user away after successful onboarding, e.g., to dashboard
    // This would be called by SuccessOnboarding's onClose prop or WelcomeOnboarding's onClose
    console.log("Onboarding finished or closed, CPVs selected:", selectedCpvs);
    navigate('/'); // Navigate to home page
  };

  return (
    <div className="min-h-screen w-screen overflow-y-auto flex flex-col items-center justify-center p-8 relative bg-[#284F82] bg-center bg-cover bg-[url('/public/images/onboarding_bg.webp')]">
      <div
        className={`bg-white shadow-xl rounded-lg max-w-4xl w-full overflow-y-auto max-h-[80vh]`}
      >
        {/* Header common to all steps on this page can go here if desired */}
        {/* Or each component can manage its own full-page appearance */}

        {currentPage === "welcome" && (
          <WelcomeOnboarding
            onClose={handleFinishOnboarding} // Or navigate to '/' or another appropriate action
            onNext={handleWelcomeNext}
          />
        )}

        {currentPage === "keywords" && (
          <BrancheOnboarding
            onClose={handleGoBack} // Go back to welcome
            onNext={handleBrancheNext} // Pass the refactored handler directly
            keywords={keywordsList}
            setKeywords={setKeywordsList}
          />
        )}

        {currentPage === "results" && (
          <ResultsOnboarding
            keywords={keywordsList}
            selection={selectedCpvs}
            setSelection={setSelectedCpvs}
            onNext={handleResultsNext} // Pass the refactored handler directly
            onClose={handleGoBack}
          />
        )}
      </div>
    </div>
  );
};

export default NoCpvsPage;
